import { fetchFamily } from '@gn-audio/core/api/product-catalogue/fetch-family';
import { fetchGroup } from '@gn-audio/core/api/product-catalogue/fetch-group';
import { fetchProduct } from '@gn-audio/core/api/product-catalogue/fetch-product';
/**
 * Fetches for a product by product ID, product type and include type.
 * @param productId Numeric product ID.
 * @param productType One of `ProductType` enumeration values. Default: `ProductType.Family`
 * @param includeType One of `IncludeType` enumeration values. Default: `IncludeType.Available`
 * @returns Promise with loaded product or `null` if product is not loaded or does not exist.
 */
export var fetchProductByType = function (productId, productType, includeType) {
    var promise;
    switch (productType) {
        case "g" /* Group */:
            promise = fetchGroup(productId, includeType);
            break;
        case "p" /* Product */:
            promise = fetchProduct(productId, includeType);
            break;
        case "f" /* Family */:
        default:
            promise = fetchFamily(productId, includeType);
            break;
    }
    return promise;
};
